module.exports = __webpack_public_path__ + "static/one-drive-b1917536d7a9c08a5ed8869c192159cb.png";